import { render, staticRenderFns } from "./Standart.vue?vue&type=template&id=a36a5304&"
import script from "./Standart.vue?vue&type=script&lang=js&"
export * from "./Standart.vue?vue&type=script&lang=js&"
import style0 from "./Standart.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports